export default function warn(msg) {
    console.error("[Rabbit] Error: " + msg);
    return;
}
